import { connect } from 'react-redux'
import { setSearchHelperVisible } from 'redux/actions'
import SearchHelper from 'components/layout/search/SearchHelper'

const mapStateToProps = state => ({
  searchHelperVisible: state.search.searchHelperVisible
})

const mapDispatchToProps = dispatch => ({
  setSearchHelperVisible: searchHelperVisible => dispatch(setSearchHelperVisible(searchHelperVisible))
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchHelper)
